import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useForm, FormProvider } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import { DatePicker } from "antd";
import {
    ChangeEvent,
    Dispatch,
    SetStateAction,
    useEffect,
    useRef,
    useState,
} from "react";
import moment, { Moment } from "moment";
import { MoneyReaisFieldMask } from "../../../../Validations/InputMasks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ListarEstadosController } from "../../../../Controllers/Geral/CadastrarCliente/CadastrarClienteController";
import {
    ICustoPrevistoVGVMensal,
    ICustoPrevistoVGVMensalPayload,
} from "../../../../Interfaces/AssistenciaTecnica/CustoPrevistoVGVMensal/CustoPrevistoVGVMensalInterface";
import Select from "react-select";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";

interface IFiltroCustoPrevistoVGVMensal {
    handleFilterFormSubmit(formData: ICustoPrevistoVGVMensalPayload): void;
    filter: ICustoPrevistoVGVMensalPayload | undefined;
    filtroInicial: ICustoPrevistoVGVMensalPayload;
    ano: string;
    mes: string;
    setPage: (page: number) => void;
    setMes: Dispatch<SetStateAction<string>>;
    setAno: Dispatch<SetStateAction<string>>;
    setFilter: (filter: any) => void;
    setDsPraca: Dispatch<SetStateAction<string | undefined>>;
}

export default function FiltroCustoPrevistoVGVMensal(
    props: IFiltroCustoPrevistoVGVMensal
) {
    const formMethods = useForm();

    const { reset } = formMethods;

    function geradorMascaraFinanceira(
        inputName: keyof ICustoPrevistoVGVMensal
    ) {
        return (e: ChangeEvent<HTMLInputElement>) => {
            const mask = MoneyReaisFieldMask(e);
            formMethods?.setValue(inputName, mask);
        };
    }

    function onChangeAno(date: Moment | null, dateString: string) {
        props.setAno(dateString);
    }

    function onChangeMes(date: Moment | null, dateString: string) {
        props.setMes(dateString);
    }

    const limparFiltros = () => {
        props.setAno("");
        props.setMes("");
        props.setDsPraca("");
        praca.current?.clearValue();
    };

    const praca = useRef<any>(null);

    const [options, setOptions] = useState<
        Array<{ value: number; label: string }> | undefined
    >();

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    const { value: lstEstado } = useAsyncEffect(
        () => ListarEstadosController(),
        []
    );

    useEffect(() => {
        setOptions(() =>
            lstEstado?.map((empreendimento) => ({
                label: empreendimento.DS_SIGLA,
                value: empreendimento.ID_ESTADO,
            }))
        );
    }, [lstEstado]);

    return (
        <FormProvider {...formMethods}>
            <UnForm handleSubmit={props.handleFilterFormSubmit} usingContext>
                <label>Praça</label>
                <Select
                    name="ID_PRACA"
                    ref={praca}
                    options={options}
                    isClearable
                    onChange={(e) => {
                        props.setDsPraca(e?.label ? e.label : "");
                    }}
                    components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                    }}
                    styles={customStyles}
                    placeholder={""}
                    noOptionsMessage={() => "Nenhuma opção"}
                    className="mb-3"
                />

                <UnForm.Input
                    label="Valor de Venda"
                    name="VL_VENDA"
                    className="mb-3"
                    registerOptions={{
                        setValueAs: (v: string) => {
                            return Number(MoneyReaisFieldMask.unMask(v));
                        },
                        required: "Insira um valor",
                    }}
                    onChange={geradorMascaraFinanceira("VL_VENDA")}
                    defaultValue={props.filter?.VL_VENDA}
                />

                <label>Mês</label>
                <DatePicker
                    picker="month"
                    onChange={onChangeMes}
                    className="form-control mb-3"
                    placeholder=""
                    format={"MM"}
                    value={props.mes ? moment(props.mes, "MM") : null}
                    defaultValue={moment(props.filter?.MES, "MM")}
                />

                <label>Ano</label>
                <DatePicker
                    picker="year"
                    onChange={onChangeAno}
                    className="form-control mb-3"
                    placeholder=""
                    value={props.ano ? moment(props.ano, "YYYY") : null}
                    defaultValue={moment(props.filter?.ANO, "YYYY")}
                />

                <UnForm.SubmitButton
                    className="w-100"
                    wrapperClassName="w-100 d-flex align-items-end justify-content-start mt-3"
                    icon={faFilter}
                    color="dark"
                    outline
                >
                    Filtrar
                </UnForm.SubmitButton>
                <button
                    type="button"
                    onClick={() => {
                        window.sessionStorage.removeItem(
                            "FILTRO_CUSTOS_PREVISTO_VGV_MENSAL"
                        );
                        props.setFilter(props.filtroInicial);
                        reset(props.filtroInicial);
                        props.setPage(1);
                        limparFiltros();
                    }}
                    className="btn btn-block btn-outline-danger mt-2"
                >
                    <FontAwesomeIcon icon={faTimes} className="mr-2" />
                    Limpar Filtros
                </button>
            </UnForm>
        </FormProvider>
    );
}
